// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var _a;
import { ETemplateType } from "./templates";
export var ReportActions;
(function (ReportActions) {
    ReportActions["EDIT"] = "edit";
    ReportActions["DELETE"] = "delete";
    ReportActions["GENERATE"] = "generate";
    ReportActions["PREVIEW"] = "preview";
    ReportActions["GENERATE_SCHEDULED"] = "generate-scheduled";
})(ReportActions || (ReportActions = {}));
export var EReportType;
(function (EReportType) {
    EReportType["INITIALIZATION_REPORT"] = "INITIALIZATION_REPORT";
    EReportType["ELECTORAL_RESULTS"] = "ELECTORAL_RESULTS";
    EReportType["BALLOT_IMAGES"] = "BALLOT_IMAGES";
    EReportType["BALLOT_RECEIPT"] = "BALLOT_RECEIPT";
    EReportType["ACTIVITY_LOGS"] = "ACTIVITY_LOGS";
    EReportType["MANUAL_VERIFICATION"] = "MANUAL_VERIFICATION";
    EReportType["PARTICIPATION_REPORT"] = "PARTICIPATION_REPORT";
    EReportType["CREDENTIALS"] = "CREDENTIALS";
})(EReportType || (EReportType = {}));
export var EReportElectionPolicy;
(function (EReportElectionPolicy) {
    EReportElectionPolicy["ELECTION_REQUIRED"] = "ELECTION_REQUIRED";
    EReportElectionPolicy["ELECTION_ALLOWED"] = "ELECTION_ALLOWED";
    EReportElectionPolicy["ELECTION_NOT_ALLOWED"] = "ELECTION_NOT_ALLOWED";
})(EReportElectionPolicy || (EReportElectionPolicy = {}));
export var reportTypeConfig = (_a = {},
    _a[EReportType.INITIALIZATION_REPORT] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.INITIALIZATION_REPORT,
    },
    _a[EReportType.ELECTORAL_RESULTS] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.ELECTORAL_RESULTS,
    },
    _a[EReportType.BALLOT_IMAGES] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.BALLOT_IMAGES,
    },
    _a[EReportType.BALLOT_RECEIPT] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.BALLOT_RECEIPT,
    },
    _a[EReportType.ACTIVITY_LOGS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.ACTIVITY_LOGS,
    },
    _a[EReportType.MANUAL_VERIFICATION] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.MANUAL_VERIFICATION,
    },
    _a[EReportType.PARTICIPATION_REPORT] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_ALLOWED,
        associatedTemplateType: ETemplateType.PARTICIPATION_REPORT,
    },
    _a[EReportType.CREDENTIALS] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.CREDENTIALS,
    },
    _a.default = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
    },
    _a);
export var EGenerateReportMode;
(function (EGenerateReportMode) {
    EGenerateReportMode["REAL"] = "REAL";
    EGenerateReportMode["PREVIEW"] = "PREVIEW";
})(EGenerateReportMode || (EGenerateReportMode = {}));
